//2021-10-29

class ProgressBar
{
	_container = null;
	_bar = null;
	_progress = null;
	
	constructor(targetElement)
	{
		this._container = document.createElement('div');
		this._container.classList.add('progressContainer');
		
		this._bar = document.createElement('div');
		this._bar.classList.add('progressBar');
		
		this._progress = document.createElement('div');
		this._progress.classList.add('progress');
		
		this._bar.appendChild(this._progress);
		this._container.appendChild(this._bar);
		
		if(typeof(targetElement) !== 'undefined')
		{
			this._container.appendChild(targetElement);
		}
	}
	
	setProgress(percent)
	{
		percent = Math.min(100, Math.max(percent, 0));
		
		this._progress.style.width = percent+'%';
	}
	
	show()
	{
		this._container.style.display = '';
	}
	
	hide()
	{
		this._container.style.display = 'none';
	}
	
	getContainer()
	{
		return this._container;
	}
}

class Progress
{
	static ProgressBar(targetElement)
	{	//2016-11-25
		
		return new ProgressBar(targetElement);
	}
};

export default Progress;